import { useQuery } from '@tanstack/react-query';
import { usePurchasingApi } from './use-purchasing-api';

const QK_HAS_EVER_PURCHASED = ['purchases', 'has-ever-purchased'] as const;

export function useHasEverPurchased() {
  const { purchasingApi } = usePurchasingApi();

  return useQuery<boolean>({
    queryKey: QK_HAS_EVER_PURCHASED,
    queryFn: async () => (await purchasingApi.getPurchases({ limit: 1 })).length > 0,
  });
}
